module.exports = __webpack_public_path__ + "media/3_9.4aa5c04b.wav";